import { useAuth } from '@/auth';
import { GlobalNavigation } from '@/components/GlobalNavigation';
import { PageHeader } from '@/components/PageHeader';
import { trpcClient } from '@/lib/trpc';
import { Flex } from '@televet/kibble-ui/chakra';
import {
  createFileRoute,
  Outlet,
  redirect,
  useMatches,
} from '@tanstack/react-router';
import { TRPCClientError } from '@trpc/client';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    const { isAuthenticated } = await context.auth.awaitAuthState();
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
    try {
      await trpcClient.user.getCurrentAdminUser.query();
    } catch (error) {
      if (
        error instanceof TRPCClientError &&
        error.data?.code === 'FORBIDDEN'
      ) {
        throw redirect({
          to: '/login',
          search: {
            redirect: location.href,
            error: 'admin_access_required',
          },
        });
      }
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { isLoading, isAuthenticated } = useAuth();
  const matches = useMatches();

  // Get the page title from the deepest matching route that defines one
  const pageTitle = matches
    .slice()
    .reverse()
    .find((match) => !!match.context.pageTitle)?.context.pageTitle;

  if (isLoading || !isAuthenticated) {
    return null;
  }

  return (
    <Flex className="AuthenticatedLayout" h="100dvh" w="100%">
      <GlobalNavigation />
      <Flex
        className="RootLayout__Content"
        flex="1 1 auto"
        // Without it this column grows to its widest table and the whole page scrolls sideways.
        minW={0}
        direction="column"
        align="stretch"
        h="100%"
        bg="bg.subtle"
      >
        {pageTitle && <PageHeader title={pageTitle} />}
        <Outlet />
      </Flex>
    </Flex>
  );
}
